import {Component, inject, OnInit} from '@angular/core';
import {ActivatedRoute, Event, NavigationStart, Router, RouterOutlet, RoutesRecognized} from '@angular/router';
import {NbAuthService} from '@nebular/auth';
import {TranslateService} from '@ngx-translate/core';
import {ConfigService, I18nService, PerimetersService, QuotePartService, WorkflowService} from './@core/utils';

import {AnalyticsService} from './@core/utils';
import {filter} from 'rxjs/operators';

import {FaConfig, FaIconLibrary} from '@fortawesome/angular-fontawesome';
import {fal} from '@fortawesome/pro-light-svg-icons';
import {fas} from '@fortawesome/pro-solid-svg-icons';
import {fat} from '@fortawesome/pro-thin-svg-icons';

@Component({
  selector: 'app-app',
  template: '<router-outlet></router-outlet>',
  standalone: true,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {

  configService = inject(ConfigService);
  quotePartService = inject(QuotePartService);
  workflowService = inject(WorkflowService);

  constructor(
    private analytics: AnalyticsService,
    private auth: NbAuthService,
    private router: Router,
    private translate: TranslateService,
    private i18n: I18nService,
    private perimeters: PerimetersService,
    private route: ActivatedRoute,
    private faIconLibrary: FaIconLibrary,
    private faIconService: FaConfig,
  ) {
    this.translate.setDefaultLang('en');
    this.i18n.setLanguage();
    this.i18n.language$.subscribe((language) => {
      this.translate.use(language);
    });
    this.faIconService.defaultPrefix = 'fal';
    this.faIconLibrary.addIconPacks(fas, fal, fat);
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    // Upon intial website opening, we do not have acces to the query params (thanks angular !)
    // So we have to implement a work around to recover the possible jwt passed in parameter
    // (https://github.com/angular/angular/issues/12157)
    this.router.events.subscribe((event: Event) => {
      if (!!event && event instanceof RoutesRecognized) {
        const queryParams = event.state.root.firstChild.queryParams;
        if (queryParams.jwt) {
          // If a jwt is in the url paramters we used it to authenticate the user
          this.auth.authenticate('jwt', queryParams.jwt).subscribe();
        }
      }
    });

    this.auth.onAuthenticationChange().pipe(
    ).subscribe((authenticated) => {
      if (!!authenticated) {
        // Fetch the customer config
        this.configService.fetchCustomerConfig();
        this.quotePartService.getQuoteParts();
        this.workflowService.loadInvestmentPlans();
      } else {
        this.perimeters.updateSelectedPerimeters([], []);
      }
    });

    // After the route has changed get last URL

    this.router.events.pipe(
      filter((event) => event instanceof NavigationStart),
    ).subscribe(() => {
      const returnUrl = this.route.snapshot.queryParams?.returnUrl;
      if (returnUrl) {
        const url = `${window.location.origin}/${returnUrl}`
        window.location.href = url;
      }
    })
  }

}
